export default __webpack_public_path__ + "static/media/api.d6e008e4.svg";